import { useTranslation } from 'react-i18next'

export const useSTAYS = () => {
  const { t } = useTranslation('webhook')

  return {
    id: 'STAYS',
    type: 'webhook',
    name: t('stays.widgetName'),
    description: t('stays.widgetDescription'),
    color: 'lightPurple',
    image: '/services/stays.webp',
    categories: [t('stays.widgetCategory')],
    service: 'stays',
    onClick: () => {},
    initialState: {
      data: {}
    }
  }
}
